import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { NavLink } from 'react-router-dom';
import SectionItemFormSection from './SectionItemFormSection';
import { sectionItemTypeIcons } from './RenderSectionItems';
import { LEARNING_ASSET_TYPES } from '../../../../../shared/Constants';
import ReviewWorkspaceCommentDisplay from '../../../../../shared/containers/ReviewWorkspace/ReviewWorkspaceCommentDisplay';

class RenderComments extends PureComponent {
    static propTypes = {
        currentValues: PropTypes.object,
        currentSectionItem: PropTypes.object,
        type: PropTypes.oneOf([
            LEARNING_ASSET_TYPES.TRACK,
            LEARNING_ASSET_TYPES.ACTIVITY,
            LEARNING_ASSET_TYPES.ARTICLE,
            LEARNING_ASSET_TYPES.SINGLE_PAGE_ACTIVITY,
            LEARNING_ASSET_TYPES.VIDEO,
            LEARNING_ASSET_TYPES.IMPACT_PROJECT,
            LEARNING_ASSET_TYPES.ASSESSMENT,
            LEARNING_ASSET_TYPES.PRE_ASSESSMENT,
            LEARNING_ASSET_TYPES.POST_ASSESSMENT,
            LEARNING_ASSET_TYPES.FEEDBACK
        ]),
        userReviews: PropTypes.array,
        selectedSectionId: PropTypes.string,
        learningAssetId: PropTypes.string,
        selectedSectionItemId: PropTypes.string,
        swapItem: PropTypes.func.isRequired,
        onResolved: PropTypes.func.isRequired,
        onDeleteSectionItem: PropTypes.func.isRequired,
        changeFormValue: PropTypes.func.isRequired,
        assetLinkOptions: PropTypes.array,
        globalSectionItems: PropTypes.array,
        currentLearningAsset: PropTypes.object,
        loggedInUserId: PropTypes.string,
        handleAssetReviewItemSubmit: PropTypes.func,
        getLearningAsset: PropTypes.func,
        onDelete: PropTypes.func,
        isContentAdmin: PropTypes.bool
    };

    onResolve = (review) => () => this.props.onResolved(review);

    onDelete = (review) => () => this.props.onDelete(review);

    handleAssetReviewItemSubmit = (assetReviewItem) => {
        const { handleAssetReviewItemSubmit, currentSectionItem } = this.props;
        const assetReviewItemBody = {
            sectionItemId: currentSectionItem.id,
            ...assetReviewItem
        };
        return handleAssetReviewItemSubmit(assetReviewItemBody);
    };

    renderComments = (reviews) =>
        reviews.map((review) =>
            !review.isDeleted ? (
                <ReviewWorkspaceCommentDisplay
                    assetReviewItem={review}
                    onResolve={this.onResolve}
                    onDelete={this.onDelete}
                    loggedInUserId={this.props.loggedInUserId}
                    isBuilder={true}
                    handleAssetReviewItemSubmit={this.handleAssetReviewItemSubmit}
                    key={review._id}
                    isContentAdmin={this.props.isContentAdmin}
                />
            ) : null
        );

    renderHeading = () => {
        const { currentSectionItem, currentLearningAsset } = this.props;

        return (
            <div className={'row comment-header-container'}>
                <h4 className={'learning-asset-title'}>{currentLearningAsset.name}</h4>
                <h4 className={'comment-heading'}>
                    <i className={`${sectionItemTypeIcons[currentSectionItem.type.toUpperCase()]}`} />
                    {currentSectionItem.name}
                </h4>
            </div>
        );
    };

    render() {
        const {
            userReviews = [],
            assetLinkOptions,
            currentValues,
            selectedSectionId,
            selectedSectionItemId,
            type,
            changeFormValue,
            swapItem,
            learningAssetId,
            onDeleteSectionItem,
            globalSectionItems,
            getLearningAsset
        } = this.props;
        const sortedReviews = userReviews.sort((a) => (a.status === 'OPEN' ? -1 : 1));
        const userComments = this.renderComments(sortedReviews);

        return (
            <section className={'row'}>
                <div className={cns('col-md-3', 'trackSectionPanel', 'comment-panel')}>
                    <section className={'pagePanel'}>
                        {this.renderHeading()}
                        <div className={'col-12 comments-container'}>{userComments}</div>
                        <div className={'col-12'}>
                            <NavLink to={`/editlearningasset/${learningAssetId}/builder`}>
                                <i className={'fal fa-arrow-circle-left back-button'} />
                                <span className={'back-text'}>BACK</span>
                            </NavLink>
                        </div>
                    </section>
                </div>
                <div className={cns('col-md-9', 'trackSectionBuilder')}>
                    <SectionItemFormSection
                        assetLinkOptions={assetLinkOptions}
                        currentValues={currentValues}
                        type={type}
                        selectedSectionId={selectedSectionId}
                        selectedSectionItemId={selectedSectionItemId}
                        swapItem={swapItem}
                        onDeleteSectionItem={onDeleteSectionItem}
                        changeFormValue={changeFormValue}
                        globalSectionItems={globalSectionItems}
                        getLearningAsset={getLearningAsset}
                    />
                </div>
            </section>
        );
    }
}

export default RenderComments;
